var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Filter function.
 *
 * @since 3.5.7
 * */
export default function () {
    /**
     * This is called filter in WooCommerce Blocks.
     * - To learn more you can go to : https://github.com/woocommerce/woocommerce-blocks/blob/trunk/docs/third-party-developers/extensibility/checkout-block/available-filters.md
     * */
    var registerCheckoutFilters = wc.blocksCheckout.registerCheckoutFilters;
    var select = wp.data.select;
    /**
     * Filter Coupons - Custom Coupon label.
     * 1. Check if the coupon has a custom_label from Store API.
     * 2. If it doesn't have a custom_label then return coupon;
     * 3. but if it has then return the custom_label.
     * */
    registerCheckoutFilters('advanced-coupons-extension', {
        coupons: function (coupons) {
            var store = select('wc/store/cart');
            var cartData = store.getCartData();
            var acfwp_block = cartData.extensions.acfwp_block;
            // Return coupons with custom label.
            return coupons.map(function (coupon) {
                var advanced_coupon = acfwp_block.coupons.find(function (item) { return item.code === coupon.code; });
                return __assign(__assign({}, coupon), { label: advanced_coupon.label ? advanced_coupon.label : coupon.label });
            });
        },
    });
}
